import { initTea, setTeaConfig } from '$tea';
import cookieConfigManager from './cookie-consent-manager';
import { Consent, DisabledAccessKeysConfig } from '../interface/cookie-banner';

export type UserConfig = {
  region: string;
  isFTC: boolean;
  i18n: { [key: string]: string };
  disabled: boolean;
  isEffective: boolean;
  consent: Consent;
  disabledAccessKeys: DisabledAccessKeysConfig;
  consentApiDomain?: string;
  customTheme: string;
  idcRegion: string;
  disableTea: boolean;
  tenantId: string;
  tea: any;
};

export function readUserConfig(userConfigEleId: string, locale: string): UserConfig | null {
  let userConfig: string | undefined | null;
  try {
    userConfig = document.getElementById(userConfigEleId)?.textContent;
    const {
      i18n = {},
      appProps: { region = '', user: { ftcUser = false } = {}, idcRegion = '' } = {},
      cookieBanner: {
        disabled = false,
        isEffective = false,
        settings = {},
        version = '',
        disabledAccessKeys = [],
        resource = {},
      } = {},
      consent,
      consentApiDomain,
      customTheme = [],
      tea,
      tenantId,
    } = JSON.parse(userConfig as string);

    initTea(tea);
    cookieConfigManager.setCookieConfig({
      settings,
      version,
      entityKeys: consent.entityKeys,
      collectionPointId: consent.collectionPointId,
    });
    setTeaConfig({
      locale,
      region,
      js_version: resource?.version ?? 'default',
      tenant_id: tenantId || 'default',
    });
    return {
      region,
      isFTC: ftcUser,
      i18n,
      disabled,
      isEffective,
      consent,
      disabledAccessKeys,
      consentApiDomain,
      customTheme: customTheme.join(';') || '',
      idcRegion,
      disableTea: resource?.esm?.includes('no-tea'),
      tenantId,
      tea,
    };
  } catch (e) {
    console.error(e);
    return null;
  }
}
